import { Chat } from "./chatsSlice"
import { chatReplyKey, ComposerSurface } from "./chatRepliesSlice"
import { Message } from "./messagesSlice"
import { RootState } from "./store"

export const selectChatReplyMessage =
  (chat: Chat, surface: ComposerSurface) => (state: RootState) => {
    return state.chatReplies[chatReplyKey(chat.jid, surface)] as
      | Message
      | undefined
  }
